import { render, staticRenderFns } from "./AlphabetTable.vue?vue&type=template&id=de695780"
import script from "./AlphabetTable.vue?vue&type=script&lang=js"
export * from "./AlphabetTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports